import * as THREE from 'three'
import { viewport, isMobile } from './viewport.js'

const mouse = new THREE.Vector2(9999, 9999)
const raycaster = new THREE.Raycaster()
const mousePlane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0)
const mouseIntersectPoint = new THREE.Vector3()
const tempWorldDir = new THREE.Vector3()
const previousMouseWorld = new THREE.Vector3(9999, 9999, 9999)

export const mouseWorld = new THREE.Vector3(9999, 9999, 9999)
export const mouseVelocity = new THREE.Vector3()
export const smoothedMouseVelocity = new THREE.Vector3()

export let isMouseDown = false
export let suckAmount = 0
export let isTouchWindMode = false

let activeTouches = 0

const isOverUI = (event) => event.target.closest('.tp-dfwv')

export const initInput = (canvas, camera, controls) => {
    window.addEventListener('pointermove', (event) => {
        if (isOverUI(event)) {
            mouse.set(9999, 9999)
            mouseWorld.set(9999, 9999, 9999)
            return
        }
        mouse.x = (event.clientX / viewport.width) * 2 - 1
        mouse.y = -(event.clientY / viewport.height) * 2 + 1
    })

    if (isMobile) {
        controls.enableRotate = false
        controls.enableZoom = false
        controls.enablePan = false

        canvas.addEventListener('touchstart', (event) => {
            if (isOverUI(event)) return
            activeTouches = event.touches.length
            if (activeTouches === 1) {
                isMouseDown = true
                isTouchWindMode = false
            } else if (activeTouches >= 2) {
                isMouseDown = false
                isTouchWindMode = true
                const t0 = event.touches[0]
                const t1 = event.touches[1]
                mouse.x = ((t0.clientX + t1.clientX) / 2 / viewport.width) * 2 - 1
                mouse.y = -((t0.clientY + t1.clientY) / 2 / viewport.height) * 2 + 1
            }
        }, { passive: true })

        canvas.addEventListener('touchmove', (event) => {
            if (isOverUI(event)) return
            if (event.touches.length >= 2) {
                const t0 = event.touches[0]
                const t1 = event.touches[1]
                mouse.x = ((t0.clientX + t1.clientX) / 2 / viewport.width) * 2 - 1
                mouse.y = -((t0.clientY + t1.clientY) / 2 / viewport.height) * 2 + 1
            } else if (event.touches.length === 1) {
                mouse.x = (event.touches[0].clientX / viewport.width) * 2 - 1
                mouse.y = -(event.touches[0].clientY / viewport.height) * 2 + 1
            }
        }, { passive: true })

        canvas.addEventListener('touchend', (event) => {
            activeTouches = event.touches.length
            if (activeTouches === 0) {
                isMouseDown = false
                isTouchWindMode = false
                mouse.set(9999, 9999)
                mouseWorld.set(9999, 9999, 9999)
            } else if (activeTouches === 1) {
                isMouseDown = true
                isTouchWindMode = false
                mouse.x = (event.touches[0].clientX / viewport.width) * 2 - 1
                mouse.y = -(event.touches[0].clientY / viewport.height) * 2 + 1
            }
        }, { passive: true })
    } else {
        window.addEventListener('pointerdown', (event) => { if (!isOverUI(event)) isMouseDown = true })
        window.addEventListener('pointerup', () => { isMouseDown = false })
    }

    window.addEventListener('pointerleave', () => {
        isMouseDown = false
        isTouchWindMode = false
        mouseWorld.set(9999, 9999, 9999)
    })
}

export const updateInput = (camera, deltaTime, params) => {
    raycaster.setFromCamera(mouse, camera)
    mousePlane.normal.copy(camera.getWorldDirection(tempWorldDir))
    if (raycaster.ray.intersectPlane(mousePlane, mouseIntersectPoint)) {
        mouseWorld.copy(mouseIntersectPoint)
    }

    const mouseWasOut = previousMouseWorld.x > 9000.0
    const mouseIsIn = mouseWorld.x < 9000.0
    if (!mouseWasOut && mouseIsIn && deltaTime > 0) {
        mouseVelocity.subVectors(mouseWorld, previousMouseWorld).divideScalar(deltaTime)
        const maxSpeed = 20.0
        const speed = mouseVelocity.length()
        if (speed > maxSpeed) mouseVelocity.multiplyScalar(maxSpeed / speed)
    } else {
        mouseVelocity.set(0, 0, 0)
        smoothedMouseVelocity.set(0, 0, 0)
    }
    smoothedMouseVelocity.lerp(mouseVelocity, Math.min(deltaTime * 10.0, 1.0))
    previousMouseWorld.copy(mouseWorld)

    if (isMobile && isMouseDown && !isTouchWindMode) {
        smoothedMouseVelocity.set(0, 0, 0)
        mouseVelocity.set(0, 0, 0)
    }

    const suckTarget = (isMouseDown || params.alwaysSuck) ? 1.0 : 0.0
    suckAmount += (suckTarget - suckAmount) * deltaTime * ((isMouseDown || params.alwaysSuck) ? 6.0 : 3.0)
}
